import { useContext } from "react";
import { StoredValueLayout } from "./layout/StoredValueLayout";
import { ChartSection } from "../../layout/ChartSection";
import { RefProvider } from "./store/RefContext";
import { LayoutProvider } from "./store/LayoutContext";
import { LocalStoreProvider } from "./store/LocalStore";
import { StoreContext } from "../../store/Store";

export const StoredValue = () => {
  const [store] = useContext(StoreContext);
  const { dimensions } = store;

  return (
    <ChartSection header="" height={dimensions.vh}>
      <LayoutProvider>
        <RefProvider>
          <LocalStoreProvider>
            <StoredValueLayout />
          </LocalStoreProvider>
        </RefProvider>
      </LayoutProvider>
    </ChartSection>
  );
};
